enum PermissionName {
  EXPORT_CREATE = "reports:c",
  EXPORT_UPDATE = "reports:u",
  EXPORT_DELETE = "reports:d",
  EXPORT_DOWNLOAD = "reports:ex",
  EXPORT_READ = "reports:r",
}

export default PermissionName;
